import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function NotifyMe({ product, onClose }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/notify", { email, product_slug: product.slug });
      toast.success(data.message);
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      {product && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={onClose} data-testid="notify-me-modal">
          <motion.div initial={{ scale: 0.94, y: 16, opacity: 0 }} animate={{ scale: 1, y: 0, opacity: 1 }} exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="card-surface rounded-2xl p-8 w-full max-w-md relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={onClose} className="absolute top-4 right-4 text-[#857078] hover:text-[#2E1A22]" data-testid="notify-close"><X size={18} /></button>
            <p className="font-mono-lux text-[11px] uppercase tracking-[0.3em] text-[#7E1E3F]">Coming Soon</p>
            <h3 className="font-serif-lux text-2xl text-[#2E1A22] mt-2 leading-snug">{product.name}</h3>
            <p className="text-sm text-[#857078] mt-3">Be the first to know when this piece launches. One email, no spam.</p>
            <form onSubmit={submit} className="mt-6 flex gap-2">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="flex-1 bg-[#FFFFFF] border border-[#7E1E3F]/25 rounded-full px-4 py-2.5 text-sm text-[#2E1A22] outline-none focus:border-[#7E1E3F]/60 placeholder:text-[#857078]"
                data-testid="notify-email-input" />
              <button disabled={loading}
                className="bg-[#7E1E3F] text-[#FFFFFF] text-xs font-semibold tracking-wider uppercase px-5 rounded-full hover:bg-[#5C1230] transition-colors disabled:opacity-60"
                data-testid="notify-submit-button">
                {loading ? "..." : "Notify Me"}
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
